// extracted by mini-css-extract-plugin
export var typingIndicator = "_oi-0";